import styled, {keyframes} from "styled-components";

import OnboardingTip from "@/components/organism/OnboardingTip/OnboardingTip";

export const fadeSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  width: 100dvw;
  height: 100vh;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 0.6);
  margin-left: 50px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1000;
`;

export const AnimatedOnboardingTip = styled(OnboardingTip)`
  animation: ${fadeSlideIn} 1s ease-out;
`;
